<div id="book-component" class="bookOffers" (window:beforeunload)="ngOnDestroy()">
  <div class="component-header">
    <span id="title">{{ componentName }}</span>
    <div class="icons gridster-ignore-drag">
      <!-- <mat-icon svgIcon="chain"></mat-icon> TODO adicionar quando funcionalidade estiver implementada  -->
      <!-- <mat-icon *ngIf="!newWindow && showExpandCard" id="ico-expand" svgIcon="expand" (click)="openNewWindow()">
      </mat-icon> -->
      <mat-icon matSuffix class="gridster-ignore-drag" svgIcon="centralizer-on" [matTooltip]="toolTipCenterStaircaseOFF"
        (click)="forceConfigCenterElement = !forceConfigCenterElement"
        *ngIf="tabIndex == 2 && forceConfigCenterElement"></mat-icon>
      <mat-icon matSuffix class="gridster-ignore-drag fill-none" svgIcon="centralizer-off"
        [matTooltip]="toolTipCenterStaircaseON" (click)="forceConfigCenterElement = !forceConfigCenterElement"
        *ngIf="tabIndex == 2 && !forceConfigCenterElement"></mat-icon>
      <mat-icon disableWksChange id="ico-close" svgIcon="close" (click)="removeItemFromWorkspace()"
        matTooltipPosition="above" [matTooltip]="removeFromWksTooltip">
      </mat-icon>
    </div>
  </div>
  <div class="component-content container-fluid gridster-ignore-drag">
    <app-auction-hammer *ngIf="model?.auctionHammer" [timeToOpen]="timeToOpen" [priceTheory]="priceTheory"
      [varTheory]="varTheory">
    </app-auction-hammer>
    <app-asset-input-header [symbolAutoComplete]="model?.quote" [lastTrade]="lastTrade" [coinVariation]="coinVariation"
      [showVariation]="showVariation" [hiddenInvalid]="hiddenInvalid" [variation]="variation"
      [dateLastNegotiation]="messageQuote?.dateLastNegotiation" [hourLastTrade]="messageQuote?.hourLastTrade"
      [timeUpdate]="messageQuote?.timeUpdate" [company]="company" [image]="imgName"
      (onsymbolChanged)="selectAsset($event)"></app-asset-input-header>
    <div class="book-wrapper" [ngClass]="hiddenInvalid ? 'has-msg' : ''" *ngIf="!loading">
      <mat-tab-group class="col-12" (selectedTabChange)="changeTab($event)" [selectedIndex]="tabIndex">
        <mat-tab id="tab-detail" label="Detalhado">
          <app-book-detail [symbol]="model?.quote" [tickSize]="tickSize" [subscribeBook]="hasSubscribeBook"  [componentName]="componentName"
            [tabIndex]="tabIndex">
          </app-book-detail>
        </mat-tab>
        <mat-tab id="tab-aggregated" label="Agregado">
          <app-book-aggregated [symbol]="model?.quote" [tickSize]="tickSize" [isSubscribeBook]="hasSubscribeAggregated"
            [componentName]="componentName" *ngIf="tabIndex == 1">
          </app-book-aggregated>
        </mat-tab>
        <mat-tab id="tab-staircase" label="Escada">
          <app-book-staircase [cardId]="data.id" [hasBillet]="false" [symbol]="model?.quote"
            [subscribeAggregated]="hasSubscribeAggregated" [tabIndex]="tabIndex" [messageQuote]='messageQuote'
            [componentName]="componentName" [data]="data" [forceConfigCenterElement]="forceConfigCenterElement"
            [valueInitBookStaircase]="valueInitBookStaircase" [tickSize]="tickSize" *ngIf="tabIndex == 2">
          </app-book-staircase>
        </mat-tab>
      </mat-tab-group>
    </div>
    <!-- TODO: Feature Desativado -->
    <!-- <div (window:beforeunload)="closeSheet()"></div> -->
  </div>

</div>
